import { Component, Input, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-cep',
  templateUrl: './text-cep.component.html',
  styleUrls: ['./text-cep.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextCepComponent implements OnInit {

  @Input() formGroup;

  constructor() { }

  ngOnInit() {
  }

}
